import { css, Mode, styled } from 'canoe';

import Theme from 'canoe/types/theme';

export const BoxContainer = styled.div<{
  mode?: Mode;
  isExpanded?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  isInGroup?: boolean;
  isExpandable?: boolean;
  hasBoxLabel?: boolean;
  showOverflow?: boolean;
  noBorder?: boolean;
}>`
  ${({
    theme,
    mode,
    isExpanded,
    isFirst,
    isLast,
    isInGroup,
    isExpandable,
    hasBoxLabel,
    showOverflow,
    noBorder,
  }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    max-width: 100%;
    height: 32px;
    font-size: 12px;
    color: ${theme.colors.OnyxGray};
    background-color: ${theme.colors.GlitterGrayL20};
    border: 1px solid ${theme.colors.GlitterGray};
    border-right-width: 0;
    border-radius: ${theme.borderRadius.small};
    box-sizing: border-box;
    overflow: hidden;

    ${
      showOverflow &&
      css`
        overflow: visible;
      `
    }

    ${
      noBorder &&
      css`
        border: none;
      `
    }

    ${
      !hasBoxLabel &&
      css`
        border-left-width: 0;
      `
    }

    ${
      mode === 'Dark' &&
      css`
        ${boxDarkStyles({ theme })};
      `
    }

    ${
      isInGroup &&
      css`
        ${boxGroupStyles({ isFirst, isLast })};
      `
    }

    ${
      isExpandable &&
      css`
        ${boxExpandableStyles({ isExpanded })};
      `
    }
  `}
`;

const boxDarkStyles = ({ theme }: { theme: Theme }) => css`
  background-color: ${theme.colors.OnyxGrayD10};
  border-color: ${theme.colors.OnyxGrayL10};
`;

const boxGroupStyles = ({ isFirst, isLast }: { isFirst?: boolean; isLast?: boolean }) => css`
  ${
    isFirst &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `
  }

  ${
    isLast &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      margin-top: -1px;
    `
  }

  ${
    !isFirst &&
    !isLast &&
    css`
      border-radius: 0;
      margin-top: -1px;
    `
  }
`;

const boxExpandableStyles = ({ isExpanded }: { isExpanded?: boolean }) => css`
  ${isExpanded &&
  css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
`;
